import { Component, inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { MiniFooterComponent } from './shared/components/mini-footer/mini-footer.component';
import {
  HeaderComponent,
  HeaderService,
  LangType
} from '@shared/component.header';
import { switchMap } from 'rxjs';
import { HeaderRepository } from '../@core/repositories/header.repository';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';
import { WecLoadingComponent } from './shared/components/wec-loading/wec-loading.component';
import { SnackbarComponent } from './shared/components/snackbar/snackbar.component';
import { SnackbarService } from '@shared/services/snackbar/snackbar.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MiniFooterComponent, HeaderComponent, WecLoadingComponent, SnackbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly headerRepository = inject(HeaderRepository);
  private readonly headerService = inject(HeaderService);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly translateService = inject(TranslateService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly snackbarService = inject(SnackbarService);

  @ViewChild('snackbar') snackbarComponent!: SnackbarComponent;

  ngAfterViewInit() {
    // Set reference ke snackbar component di service
    this.snackbarService.setSnackbarRef(this.snackbarComponent);
  }

  ngOnInit(): void {
    /**
     * Header menu
     */

    this.headerService.langType
      .pipe(
        switchMap((langType) => {
          return this.headerRepository.getMenuheader(langType === 'EN');
        })
      )
      .subscribe((res) => {
        this.headerService.initMenu(res);
      });

    /**
     * Header logo of paths
     */

    this.headerRepository.getLogoPaths(this.router).subscribe((res) => {
      this.headerService.setLogo(res.logoUrl);
    });

    this.headerService.headerType.next('simple');

    // this.onGetDefaultLang();
  }

  /**
   *
   * Query Params Lang Obvserver
   */
  onGetDefaultLang() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['lang']) {
        return this.translateService.use(params['lang']);
      }

      if (isPlatformBrowser(this.platformId)) {
        const url = window.location.pathname;
        return this.router.navigate([url], {
          queryParams: {
            lang: String(localStorage.getItem('lang') ?? 'ID').toLowerCase()
          }
        });
      } else {
        return;
      }
    });
  }

  onLanguageChange(lang: LangType) {
    this.translateService.use(lang.toLowerCase());
  }

}
